module.exports = __webpack_public_path__ + "img/鎏金面膜+珍银面膜_06.ed021d85.jpg";